import React from 'react';
import { useTranslation } from 'react-i18next';

export default function BeforeAfterPair({ beforeUrl, afterUrl, title }) {
  const { t } = useTranslation();

  return (
    <div className="w-full" data-testid="before-after-slider">
      {title && (
        <div className="bg-black text-white text-center py-3">
          <h3
            className="text-base font-semibold tracking-widest uppercase"
            style={{ fontFamily: 'Playfair Display' }}
          >
            {title}
          </h3>
        </div>
      )}
      <div className="grid grid-cols-2">
        <div className="relative h-[350px] md:h-[500px] lg:h-[600px] overflow-hidden">
          <img
            src={beforeUrl}
            alt="Antes"
            className="w-full h-full object-cover"
            draggable={false}
          />
          <div className="absolute top-4 left-4 bg-black bg-opacity-80 text-white px-4 py-1.5 text-xs font-bold tracking-widest">
            {t('home.before')}
          </div>
        </div>
        <div className="relative h-[350px] md:h-[500px] lg:h-[600px] overflow-hidden">
          <img
            src={afterUrl}
            alt="Después"
            className="w-full h-full object-cover"
            draggable={false}
          />
          <div className="absolute top-4 right-4 bg-black bg-opacity-80 text-white px-4 py-1.5 text-xs font-bold tracking-widest">
            {t('home.after')}
          </div>
        </div>
      </div>
    </div>
  );
}
